<template>

  <header id="home" class="cabecalho">
     <a id="home" 
     href="home"  
        v-scroll-to = " {
              el: '#home',  
              container: 'body', 
              duration: 500, 
              lazy: false,
              easing: 'ease-in-out', 
              offset: -5, 
              force: true , 
              cancelable: true,
              onStart: false,
              onDone: false,
              onCancel: false, 
              x: false, 
              y: true,
          } "
     ><img src="../assets/logo.webp" alt=""></a>
       
    <nav class="menu">
        <li><a href="home"  
        v-scroll-to = " {
              el: '#home',  
              container: 'body', 
              duration: 500, 
              lazy: false,
              easing: 'ease-in-out', 
              offset: -5, 
              force: true , 
              cancelable: true,
              onStart: false,
              onDone: false,
              onCancel: false, 
              x: false, 
              y: true,
          } "
        
        
        >Home</a></li>
        <li><a href = "#sobre" v-scroll-to = " { 
              el: '#sobre', 
              container: 'body', 
              duration: 500, 
              lazy: false,
              easing: 'ease-in-out', 
              offset: -5, 
              force: true , 
              cancelable: true,
              onStart: false,
              onDone: false,
              onCancel: false, 
              x: false, 
              y: true,
          } ">Sobre</a></li>
        <li>
          <a  href = "#skills" v-scroll-to = " { 
              el: '#skills', 
              container: 'body', 
              duration: 1000, 
              lazy: false,
              easing: 'ease-in-out', 
              offset: -150, 
              force: true , 
              cancelable: true,
              onStart: false,
              onDone: false,
              onCancel: false,
              x: false, 
              y: true 
          } " >
              Skills
          </a >
        </li>
        <li>
          <a  href = "#jobs" v-scroll-to = " { 
              el: '#jobs', 
              container: 'body', 
              duration: 500, 
              lazy: false,
              easing: 'ease-in-out', 
              offset: -120, 
              force: true , 
              cancelable: true,
              onStart: false,
              onDone: false,
              onCancel: false,
              x: false, 
              y: true 
          } " >
              Jobs
          </a >
        </li>
        <li><a href="https://abisaiweb7.medium.com/" target="_blank">Blog</a></li>
    </nav>
  </header>
</template>

<script> 




export default {

  
  
methods:{
  aparecer(){
    let open = document.querySelector('.btn-menu');
    let close = document.querySelector('.btn-close');
    let menu = document.querySelector('.menu');

    open.addEventListener('click', function() {
      menu.style.display = 'block';
    });

    close.addEventListener('click', function() {
      menu.style.display = 'none';
    });
  },
  
}

}
</script>

<style scoped>

header {
    position: fixed;  
    background-color: #fff;
    box-shadow: #243B55;
    width: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px 30px;
    box-shadow: 0 4px 25px rgba(14, 36, 49, .15);
}
header nav {
  display: flex;
  
}
header img {
  width: 200px;
  margin-right:65px;
}
header li a{
  color: var(--color-principal);
  font-size: 1.2rem;
  font-weight: 500;
  
}
header li a:hover{
  border-bottom: 3px solid var(--color-secundaria);
}
header li {
  margin: 0 15px;
}
header li:first-child{
  margin-left: 0;

}
header li:last-child{
  margin-right: 0;
}

@media (max-width:700px){
  header{
    position: fixed;  
    flex-direction: column;
  }
  header img {
    margin-right: 0;
    margin-bottom: 15px;
  }
}
</style>